import Parse from "parse";

import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Source = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface Ticket_SourceAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  source: OD3_Source;
  tenant?: OD3_Tenant;
  ticket: Ticket;
  user?: _User;
}

export class Ticket_Source extends Parse.Object<Ticket_SourceAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Source";

  constructor(data?: Partial<Ticket_SourceAttributes>) {
    super("OD3_Maintenance_Ticket_Source", data as Ticket_SourceAttributes);
  }

  get source(): OD3_Source {
    return super.get("source");
  }
  set source(value: OD3_Source) {
    super.set("source", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket {
    return super.get("ticket");
  }
  set ticket(value: Ticket) {
    super.set("ticket", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Source", Ticket_Source);
